import PageHeader from 'components/PageHeader';
import PaddedLayout from 'layout/MainLayout/PaddedLayout';
import CountryManagementTable from './CountryManagementTable';

const CountryManagementPage = (): JSX.Element => {
    return (
        <PaddedLayout className="overflow-hidden">
            <div className="flex h-full flex-col gap-4">
                <PageHeader hostsList titleId={'country-management.country-management'} showBreadcrumb />
                <CountryManagementTable />
            </div>
        </PaddedLayout>
    );
};

export default CountryManagementPage;
